var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBlueInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.843 12.605 7.803 8h-1.6V6.687h3.151l.04 4.605h1.469v1.313h-3.02Zm-.327-8.14c0-.304.09-.557.27-.758.181-.2.44-.3.776-.3s.595.1.779.3c.183.201.275.454.275.757 0 .299-.092.547-.275.745-.184.198-.443.297-.78.297-.335 0-.594-.099-.774-.297a1.063 1.063 0 0 1-.271-.745ZM8.5 14.562a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.124Zm0 1.312a7.875 7.875 0 1 1 0-15.75 7.875 7.875 0 0 1 0 15.75Z",
    fill: "#0071C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfo);
export default __webpack_public_path__ + "static/media/BlueInfo.610fa2b0970e2345ab2e412addaddbf7.svg";
export { ForwardRef as ReactComponent };